import PropTypes from "prop-types";
import { default as ReactSelect, components as RSComponents } from "react-select";

// Custom option to render label only (no checkbox icon)
const Option = (props) => (
  <RSComponents.Option {...props}>
    {props.label}
  </RSComponents.Option>
);

const SelectBox = props => {
  const mergedComponents = { ...(props.components || {}), Option };

  if (props.allowSelectAll) {
    return (
      <ReactSelect
        {...props}
        components={mergedComponents}
        options={[props.allOption, ...props.options]}
        isDisabled={props?.isDisabled}
        onChange={selected => {
          if (selected !== null && selected.length > 0 && selected[selected.length - 1].value === props.allOption.value) {
            return props.onChange(props.options);
          }
          return props.onChange(selected);
        }}
      />
    );
  }

  return <ReactSelect {...props} components={mergedComponents} />;
};

SelectBox.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number
  }),
  isDisabled: PropTypes.bool
};

SelectBox.defaultProps = {
  allOption: {
    label: "Select all",
    value: "*"
  },
  isDisabled: false,
};

export default SelectBox;
